module.exports = __webpack_public_path__ + "static/media/star_full.810e9bb9.svg";